<template>
    <div class="overview">

        <table class="table is-fullwidth is-bordered">
            <tbody>
                <tr>

                    <th>STATUS</th>

                    <!-- Long Name -->

                    <td>
                        {{ order.status }}
                        <b-tag rounded type="is-warning" title="DISPUTED" v-if="inDispute">DISPUTED</b-tag>
                    </td>

                    <!-- Short Name -->

                    <!-- <td>{{ order.status | statusDisplay }}</td> -->

                    <td :rowspan="order.problemCode ? 13 : 12" width="50%" ref="orderMapRow" style="margin:0;padding:0">

                        <table class="table is-fullwidth">
                            <tr>
                                <td colspan="2" style="margin:0px;padding: 0px;">
                                    <order-map map-id="order-map" :map-config="mapConfig" :order="order"
                                        :operations="operations" ref="orderMap" v-show="mapConfig.height" />
                                </td>
                            </tr>
                            <tr ref="trLocation" v-if="order.locationAsset">
                                <th>LOCATION</th>
                                <td>{{ order.locationAsset.assetName || order.locationAsset.thirdPartyCode }}</td>
                            </tr>
                            <tr ref="trAddress">
                                <th colspan="2">ADDRESS</th>
                            </tr>
                            <tr ref="trAddressValue">
                                <td colspan="2" style="height:7rem;">{{ order.address }}</td>
                            </tr>
                        </table>

                    </td>
                </tr>

                <tr>
                    <th>ISSUED ON</th>
                    <td>{{ order.releaseDate | toLocalDateAndTime | uppercase }}</td>
                </tr>

                <tr>
                    <th>CONTRACT</th>
                    <td>{{ order.contract ? `${order.contract.code ? `${order.contract.code} ` : ''}${order.contract.name}`
                        : '' }}</td>
                </tr>

                <tr>
                    <th>ISSUED BY</th>
                    <td>{{ order.createdByFirm ? order.createdByFirm.name : "" }}</td>
                </tr>

                <tr>
                    <th>ISSUED TO</th>
                    <td>{{ order.firm ? order.firm.name : "" }}</td>
                </tr>

                <tr>
                    <th>CLAIM ID</th>
                    <td>

                        {{ order.billing_code }}

                        <b-button size="is-small" @click="editBillingCode = true" v-if="canEditClaimDate && order.editable">
                            <i class="fa fa-pencil"></i>
                            Edit
                        </b-button>

                        <b-modal :active.sync="editBillingCode" :width="640">
                            <div class="card">
                                <div class="card-content">
                                    <div class="content">

                                        <b-field label="Billing Code">
                                            <b-input v-model="billingCode"></b-input>
                                        </b-field>

                                    </div>
                                </div>
                            </div>
                            <footer class="modal-card-foot">
                                <button class="button" type="button" @click="editBillingCode = false">Close</button>
                                <button class="button is-primary" @click="saveNewCode(order.id)">Save</button>
                            </footer>
                        </b-modal>

                    </td>
                </tr>

                <!-- BETTER TERM: REQUESTED BY -->
                <tr>
                    <th class="no-wrap">TYPE</th>

                    <!-- <td>{{ order.orderType == 'PLANNED' ? 'Healthy Waters' : 'Auckland Council' }}</td> -->
                    <td id="order_type">{{ order.orderTypeCode ? order.orderTypeCode.code : "" }}</td>
                </tr>

                <!-- BETTER TERM: BUDGET -->
                <tr>
                    <th>SUB-TYPE</th>
                    <td>{{ order.orderSubtypeCode ? order.orderSubtypeCode.name : "" }}</td>
                </tr>

                <tr v-if="order.problemCode">
                    <th class="no-wrap">PROBLEM</th>
                    <td class="no-wrap">{{ order.problemCode ? order.problemCode.name : "" }}</td>
                </tr>

                <tr>
                    <th>PRIORITY</th>
                    <td>{{ order.priority }}</td>
                </tr>

                <tr>
                    <th>MANAGED BY</th>
                    <td>

                        <b-field>
                            <b-select :disabled="!canManage || !order.editable" v-model="order.managed_by" expanded>

                                <option value="">Unassigned</option>

                                <option v-for="manager in managers" :value="manager.id" :key="manager.id">
                                    {{ manager.fullName }}
                                </option>

                            </b-select>
                        </b-field>

                    </td>
                </tr>

                <tr>
                    <th class="no-wrap">ASSIGNED TO</th>
                    <td>
                        <base-select v-if="assignedTo || canAssigned" :disabled="loading || !canAssigned || !order.editable"
                            label :service="userService" fetch-func="all" :fetch-params="{
                                firmId: order.firm.id,
                                filter_by: 'first_name',
                                active: 1,
                                archived: false,
                            }" value-key="id" defaultOptionLabel="Unassigned" v-model="assignedTo">
                            <template #customLabel="{ option }">
                                {{ option.firstName }}
                            </template>
                        </base-select>

                        <b-select expanded v-else placeholder="Unassigned" disabled></b-select>
                    </td>
                </tr>

                <tr>
                    <th class="no-wrap">REFERENCE</th> <!-- FIELD SHOULD BE STORED IN AUX_DATA -->
                    <td>
                        <input type="text" class="input" placeholder="Internal order reference"
                            v-model="partialOrderForm.contractor_job_number"
                            :disabled="!canSavePartialOrder || !canManageOperationsBoolean || !order.editable">
                    </td>
                </tr>

                <!-- <tr>
                    <th>&nbsp;</th>
                    <td>&nbsp;</td>
                </tr> -->

                <!--
                <tr>
                    <th>RETURN TO SITE?</th>
                    <td>{{ order.returnToSite }}</td>
                </tr>
                -->

                <tr>
                    <td class="no-wrap" colspan="3" style="margin:0;padding:0">
                        <order-kpi :order="order" />
                    </td>
                </tr>

                <tr>
                    <th class="no-wrap" colspan="3">CODES</th>
                </tr>
                <tr>
                    <td colspan="3">
                        <div class="scrollable" v-if="coding" style="height:unset; min-height:50px;">
                            <template v-for="(code, index) in coding.dropdownData">
                                <coding :coding="coding" :code="code" :index="index" />
                            </template>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th class="no-wrap" colspan="3">DESCRIPTION</th>
                </tr>

                <tr>
                    <td colspan="3">
                        <div class="scrollable description">
                            {{ order.workDescription }}
                        </div>
                    </td>
                </tr>

                <tr>
                    <th colspan="2">TAGS</th>
                    <th>
                        AUX DATA
                        <b-button class="is-pulled-right" @click.prevent="isAddAux = true"
                            :disabled="!order.editable">ADD</b-button>
                    </th>
                </tr>

                <tr>
                    <td colspan="2">

                        <div class="toggle-container" v-if="orderToggleTagList.length > 0 && !toggleLoading">
                            <div class="toggle-tags" v-for="(tag, index) in orderToggleTagList" :key="index">
                                <b-button :disabled="!order.editable" type="is-info" class="is-small" expanded
                                    :outlined="!isToggleTagActive(tag)" @click.prevent="switchToggleTag(tag)">
                                    {{ tag.name }}
                                </b-button>
                            </div>
                        </div>

                        <!-- <b-field grouped v-if="orderToggleTagList.length > 0">
                            <b-switch
                                v-for="(tag, index) in orderToggleTagList"
                                :key="index"
                                :native-value="tag"
                                v-model="orderToggleTags"
                            >{{ tag.name }}</b-switch>
                        </b-field>-->

                        <b-field label>
                            <b-taginput :disabled="!order.editable" v-model="orderTags" :data="filteredTagsList"
                                autocomplete :allow-new="true" :open-on-focus="false" icon="label" placeholder="Add a tag"
                                @typing="getFilteredTags" @add="tag => attachTag({ name: tag })"
                                @remove="tag => removeTag({ name: tag })">
                                <template slot-scope="props">{{ props.option }}</template>
                                <template slot="empty">No Result</template>
                            </b-taginput>
                        </b-field>

                    </td>

                    <td>
                <tr v-for="(attribute, index) in order.attributes" :key="index">
                    <th class="is-uppercase" style="min-width: 100px;">{{ attribute.name }}</th>
                    <td width="100%">{{ attribute.value }}
                        <b-button v-if="isSuperadmin && !isSystemAttribute(attribute)" :disabled="!order.editable"
                            class="is-pulled-right is-danger" @click.prevent="removeAttribute(attribute, index)"
                            size="is-small">X</b-button>
                    </td>
                </tr>
                </td>

                </tr>
            </tbody>
        </table>

        <!-- Duplicate Modal -->
        <b-modal :active.sync="isAddAux" trap-focus aria-role="dialog" aria-modal>
            <order-aux-modal :order.sync="order" />
        </b-modal>

    </div>
</template>

<script>

import moment from "moment";

// @TODO - transfer/refactor detail kpi component to Order folder

import OrderKpi from "@/components/OrderKpi/OrderKpi";
import Coding from "@/components/Order/OrderCodes";
import OrderMap from "@/components/Order/OrderMap";
import OrderAuxModal from "@/components/Order/OrderAuxModal";
import { OrderService } from "@/services/order.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import { UserService } from "@/services/user.service";
import BaseSelect from "@/components/partials/BaseSelect";
import { TagService } from "@/services/tag.service";
import debounce from "lodash/debounce";


export default {

    tagService: TagService,
    orderService: OrderService,
    props: {
        order: {
            type: Object,
            required: true
        },
        operations: {
            type: Array,
            default: () => []
        }
    },

    filters: {
        dateText(value, format = "DD-MMM-YYYY HH:mm") {
            return value
                ? moment(value)
                    .format(format)
                    .toUpperCase()
                : "";
        }
    },

    components: {
        OrderKpi,
        OrderMap,
        BaseSelect,
        OrderAuxModal,
        Coding
    },

    data: () => ({
        userService: UserService,
        assignedTo: null,
        loading: false,
        mapConfig: {
            height: 0,
            offlineDownload: false,
            scrollable: false,
            hasOfflineControl: false,
            hasZoomControl: false,
            hasLocateControl: false,
            hasLayersControl: false
        },
        busySavingPartialOrder: false,
        partialOrderForm: {
            contractor_job_number: null,
            // duplicateOf: null
        },
        modalKpi: {
            active: false,
            type: "",
            result: "",
            mode: ""
        },
        tags: [],
        filteredTagsList: [],
        orderToggleTagList: [],
        orderTags: [],
        orderToggleTags: [],
        toggleLoading: false,
        isAddAux: false,
        editBillingCode: false,
        billingCode: '',
        managers: [],
        mounted: false,
    }),
    mounted() {

        this.billingCode = this.order.billing_code;

        this.setMapHeight();
        this.getTags();
        this.getOrderToggleTags();
        this.assignedTo = this.order.assigned_to;
        this.orderTags = this.order.tags
            .filter(tag => {
                return tag.type != "order_toggle";
            })
            .map(item => item.name);
        this.orderToggleTags = this.order.tags.filter(tag => {
            return tag.type == "order_toggle";
        });
        this.refreshPartialOrderForm();

        this.fetchManagers();
    },
    watch: {
        order() {
            this.setMapHeight();
            this.assignedTo = this.order.assigned_to;
            this.refreshPartialOrderForm();
        },
        assignedTo(value) {
            if (this.order.assigned_to != value) {
                this.updateAssignedTo();
            }
        },
        orderTags() {
            // Compare the Order Tags and orderTags
            let tagsOfOrder = this.order.tags
                .filter(tag => {
                    return tag.type != "order_toggle";
                })
                .map(item => item.name);
            if (JSON.stringify(tagsOfOrder) != JSON.stringify(this.orderTags)) {
                this.$nextTick(() => {
                    // this.assignTags();
                });
            }
        },
        orderToggleTags() {
            // Compare the Order Tags and orderToggleTags
            let tagsOfOrder = this.order.tags
                .filter(tag => {
                    return tag.type == "order_toggle";
                })
                .map(item => item.name);
            let orderToggle = this.orderToggleTags.map(item => item.name);
            if (JSON.stringify(tagsOfOrder) != JSON.stringify(orderToggle)) {
                this.$nextTick(() => {
                    this.assignTags();
                });
            }
        },
        "partialOrderForm.contractor_job_number"(value) {
            if (this.order.contractor_job_number != value) {
                this.onSavePartialOrder(value);
            }
        },

        'order.managed_by'(manager_id) {

            OrderService.updatePartial(this.order.id, { managed_by: manager_id }).then(() => {


            })

        },
    },
    computed: {
        user() {
            return this.$store.state.Auth.user;
        },

        isSuperadmin() {
            return this.$store.getters["Auth/hasRole"]("superadmin")
        },

        canAssigned() {
            // return  this.order.createdByFirm && this.order.createdByFirm.id == this.order.firm.id && this.order.firm.id ==  this.user.firm.id;
            if (this.order.status === "BLAP") return false;

            return this.order.firm.id == this.user.firm.id;
        },
        canManage() {

            // return this.order.firm_id == this.user.firmId || this.order.created_by_firm_id == this.user.firmId;
            if (this.order.status === "BLAP") return false;

            return this.order.created_by_firm_id == this.user.firmId;

            // return this.order.firm.id == this.user.firm.id;

        },
        canManageOperationsBoolean() {
            // Because it's a pain to keep checking (canManageOperations && canManageOperations.value)
            const obj = this.$store.getters["OrderState/getStateByKey"]("can_manage_operations");
            return obj && obj.value;
        },
        canSavePartialOrder() {
            return (
                this.canManageOperationsBoolean
                && !this.busySavingPartialOrder
            );
        },
        canEditClaimDate() {
            return this.$store.getters["Auth/hasPermission"]("can edit claim date");
        },
        inDispute() {
            return this.$store.getters["OrderState/getStateByKey"]("in_dispute");
        },
        coding() {
            return this.order.coding;
        },
    },
    methods: {

        fetchManagers() {

            UserService.all({
                firmId: this.order.createdByFirm.id,
                filter_by: 'first_name',
                active: 1,
                archived: false,
            }).then(response => {

                this.managers = JsonDenormalizer.denormalize(response)

                // this.managed_by = this.order.managed_by

            });

        },

        async updateAssignedTo() {
            this.loading = true;
            const order = await this.$options.orderService
                .updateAssignedTo(this.order.id, {
                    assigned_to: this.assignedTo
                })
                .then(response => JsonDenormalizer.denormalize(response.data));
            this.order.assigned_to = order.assigned_to;
            this.loading = false;
        },

        saveNewCode(id) {

            OrderService.updatePartial(id, { billing_code: this.billingCode }).then(() => {

                this.editBillingCode = false;

                this.order.billing_code = this.billingCode

                this.$buefy.toast.open({
                    message: "Billing Code Saved.",
                    type: "is-success",
                    position: "is-top-right"
                });

            })


        },

        refreshPartialOrderForm() {
            this.partialOrderForm = Object.assign(
                {},
                this.partialOrderForm,
                {
                    contractor_job_number: this.order.contractor_job_number,
                    // duplicateOf: this.order.duplicateOf
                }
            );
        },



        dateFormatter(date) {
            return moment(date).format("DD/MM/YYYY HH:mm");
        },
        dateParser(date) {
            return moment(date).format("YYYY-MM-DD HH:mm:ss");
        },

        setMapHeight() {
            this.mapConfig.height = 0;

            this.$nextTick(() => {
                this.mapConfig.height = this.$refs.orderMapRow.clientHeight -
                    this.$refs.trAddress.clientHeight -
                    this.$refs.trAddressValue.clientHeight -
                    (this.$refs.trLocation ? this.$refs.trLocation.clientHeight : 0);
            });
        },

        async getTags() {
            try {
                this.tags = await this.$options.tagService
                    .all({ typeNotIncluded: "order_toggle", firm_id: this.user.firmId })
                    .then(response => JsonDenormalizer.denormalize(response));
            } catch (err) { }
        },

        async getOrderToggleTags() {
            try {
                this.orderToggleTagList = await this.$options.tagService
                    .all({ type: "order_toggle" })
                    .then(response => JsonDenormalizer.denormalize(response));
            } catch (err) { }
        },
        getFilteredTags: debounce(function (filter) {
            this.filteredTagsList = this.tags
                .filter(option => {
                    return (
                        option.name
                            .toString()
                            .toLowerCase()
                            .indexOf(filter.toLowerCase()) >= 0
                    );
                })
                .map(tag => tag.name);
        }, 200),
        async assignTags() {
            try {
                let formData = new FormData();
                formData.append("type", "order");
                formData.append("type_id", this.order.id);
                this.orderTags.forEach(tag => {
                    formData.append("tag_names[]", tag);
                });
                this.orderToggleTags.forEach(tag => {
                    formData.append("tag_names[]", tag.name);
                });

                let response = await this.$options.tagService
                    .assign(formData)
                    .then(response => JsonDenormalizer.denormalize(response));
                this.order.tags = response;
            } catch (err) {
                // Back to order Tags
                this.orderTags = this.order.tags
                    .filter(tag => {
                        return tag.type != "order_toggle";
                    })
                    .map(item => item.name);
                this.orderToggleTags = this.order.tags.filter(tag => {
                    return tag.type == "order_toggle";
                });
            }
        },
        async attachTag(tag) {
            try {
                const data = {
                    model_type: "order",
                    model_id: this.order.id,
                };

                let newTag = null;
                if (tag.id) {
                    data.tag_ids = [tag.id];
                    newTag = await this.$options.tagService.attach(data)
                        .then(response => JsonDenormalizer.denormalize(response));
                } else {
                    data.tag_names = [tag.name];
                    newTag = await this.$options.tagService.attachByNames(data)
                        .then(response => JsonDenormalizer.denormalize(response));
                }

                // Update order tags
                if (newTag) {
                    this.order.tags.push(newTag);
                }
            } catch (err) {
                // Back to order Tags
                this.orderTags = this.order.tags
                    .filter(tag => {
                        return tag.type != "order_toggle";
                    })
                    .map(item => item.name);
                this.orderToggleTags = this.order.tags.filter(tag => {
                    return tag.type == "order_toggle";
                });
            }
        },
        async removeTag(tag) {
            try {
                const data = {
                    model_type: "order",
                    model_id: this.order.id,
                };

                if (tag.id) {
                    data.tag_ids = [tag.id];
                    await this.$options.tagService.detach(data);
                } else {
                    data.tag_names = [tag.name];
                    await this.$options.tagService.detachByNames(data);
                }

                // Update order tags
                this.order.tags = this.order.tags.filter(orderTag => tag.id ? orderTag.id != tag.id : orderTag.name !== tag.name);
            } catch (err) {
                // Back to order Tags
                this.orderTags = this.order.tags
                    .filter(tag => {
                        return tag.type != "order_toggle";
                    })
                    .map(item => item.name);
                this.orderToggleTags = this.order.tags.filter(tag => {
                    return tag.type == "order_toggle";
                });
            }
        },
        isToggleTagActive(tag) {
            if (this.orderToggleTags.some(e => e.name === tag.name)) {
                return true;
            }
            return false;
        },
        switchToggleTag(tag) {
            this.toggleLoading = true;
            this.$nextTick(() => {
                if (this.isToggleTagActive(tag)) {
                    // this.orderToggleTags.splice(this.orderToggleTags.findIndex(el => el.name == tag.name), 1);
                    this.removeTag({ id: tag.id });
                } else {
                    // this.orderToggleTags.push(tag);
                    this.attachTag({ id: tag.id });
                }
                this.toggleLoading = false;
            });
        },
        onSavePartialOrder: debounce(function (reference) {
            this.busySavingPartialOrder = true;
            const payload = Object.assign({}, this.partialOrderForm);
            OrderService.updatePartial(this.order.id, payload)
                .then(() => {
                    this.order.contractor_job_number = this.partialOrderForm.contractor_job_number
                    this.$buefy.toast.open({
                        message: "Order reference saved.",
                        type: "is-success",
                        position: "is-top-right"
                    });
                })
                .catch(() => {
                    // AJAX interceptor should have handled this.
                })
                .finally(() => {
                    this.busySavingPartialOrder = false;
                });
        }, 1000),

        async removeAttribute(attribute, index) {
            this.loading = true;

            let params = { type_id: attribute.id, includes: 'attributes' }

            let response = await this.$options.orderService
                .removeAttribute(this.order.id, params)
                .then(response => JsonDenormalizer.denormalize(response));

            this.$buefy.toast.open({
                message: "AUX data was removed.",
                type: "is-success",
                position: "is-top-right"
            });

            this.$delete(this.order.attributes, index);

            this.loading = false;

        },
        // Move this to a mixin if used in other parts of the system
        isSystemAttribute(attribute) {
            return attribute.code.includes("[SYSTEM]");
        },
    }
};

</script>

<style lang="scss">
.overview {

    td {
        //word-break: break-all;
    }

    .description {
        height: 7rem !important;
    }

    .toggle-container {

        display: flex;
        flex-wrap: wrap;
        margin-bottom: 0.5rem;

        .toggle-tags {

            flex: 0 0 33.33%;
            max-width: 33.33%;
            padding: 2px;

            .button {
                height: 100%;
                min-height: 2.25em;

                span {
                    white-space: normal;
                }
            }

        }

    }

}
</style>

<style scoped>
/*{
  display: flex;
  justify-content: center;
  align-items: center;
}*/
</style>


// WEBPACK FOOTER //
// src/components/Order/OrderOverview.vue